import React, { useEffect, useState } from 'react';

import '../../assets/MyStyles.scss';

import Tabs from './Tabs'


export default function RequestPanel(props) {

    const request = props.request;


    if (request == undefined) {
        return (
            <div className='text-left'>
                <h2 className=' text-center ib-bg p-4'>Request</h2>
                <p>Please select request from the table</p>
            </div>
        )

    } else {
        return (
            <div className='text-left'>
                <h2 className=' ib-bg p-4'>Request <span className='ib-dark'>{request.url}</span> </h2>
                <p>Description: {request.sender} </p>
                <p>Source IP: {request.sourceIp} </p>
                <p>Arrival time: {request.date} </p>
                <p>Method: {request.method == 'GET' ? <span className="green-color">{request.method}</span> 
                            : <span className="blue-color">{request.method}</span>}
                </p>  
                <h3 className='ib-bg  py-2 px-4 mb-0 text-center'>Data </h3>              
                <Tabs request={request}/>
            </div>
        )
    }
}


